import styled, { css } from 'styled-components';
import { palette } from './colors';
import defaultValidatorFn from "@emotion/is-prop-valid";


const getProp = (props, propName) => {
    return props['$' + propName] || props[propName];
};

export const FlexDiv = styled.div.withConfig({
    shouldForwardProp: (prop) =>
      defaultValidatorFn(prop)
})`
    display: flex;
    max-width: 100%;
    flex-wrap: wrap;
    ${(props) =>
        getProp(props, 'backgroundColor') &&
        css`
            background: ${getProp(props, 'backgroundColor')};
        `}
    ${(props) =>
        props.dropShadowBelow &&
        css`
            box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.04),
                0px 4px 24px rgba(29, 30, 29, 0.04);
        `}
    ${(props) =>
        props.dropShadowAbove &&
        css`
            box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08),
                0px 4px 24px rgba(29, 30, 29, 0.08);
        `}
    ${(props) =>
        props.$noWrap &&
        css`
            flex-wrap: nowrap;
        `}
    ${(props) =>
        props.padding &&
        css`
            padding: ${props.padding}px;
        `}
    ${(props) =>
        props.py &&
        css`
            padding-top: ${props.py}px;
            padding-bottom: ${props.py}px;
        `}
    ${(props) =>
        props.px &&
        css`
            padding-left: ${props.px}px;
            padding-right: ${props.px}px;
        `}
    ${(props) =>
        props.pt &&
        css`
            padding-top: ${props.pt}px;
        `}
    ${(props) =>
        props.pr &&
        css`
            padding-right: ${props.pr}px;
        `}
    ${(props) =>
        props.pb &&
        css`
            padding-bottom: ${props.pb}px;
        `}
    ${(props) =>
        props.pl &&
        css`
            padding-left: ${props.pl}px;
        `}
    ${(props) =>
        props.margin &&
        css`
            margin: ${props.margin}px;
        `}
    ${(props) =>
        props.my &&
        css`
            margin-top: ${props.my}px;
            margin-bottom: ${props.my}px;
        `}
    ${(props) =>
        props.mx &&
        css`
            margin-left: ${props.mx}px;
            margin-right: ${props.mx}px;
        `}
    ${(props) =>
        props.mt &&
        css`
            margin-top: ${props.mt}px;
        `}
    ${(props) =>
        props.mr &&
        css`
            margin-right: ${props.mr}px;
        `}
    ${(props) =>
        props.mb &&
        css`
            margin-bottom: ${props.mb}px;
        `}
    ${(props) =>
        props.ml &&
        css`
            margin-left: ${props.ml}px;
        `}
    ${(props) =>
        props.marginAuto &&
        css`
            margin: auto;
        `}
    ${(props) =>
        props.marginLeftAuto &&
        css`
            margin-left: auto;
        `}
    
    ${(props) =>
        getProp(props, 'alignCenter') &&
        css`
            align-items: center;
        `}
    ${(props) =>
        getProp(props, 'textAlignCenter') &&
        css`
            text-align: center;
        `}
    ${(props) =>
        props.alignStretch &&
        css`
            align-items: stretch !important;
        `}
    ${(props) =>
        props.justifyCenter &&
        css`
            justify-content: center;
        `}
    
    ${(props) =>
        props.alignStart &&
        css`
            align-items: flex-start !important;
        `}
    ${(props) =>
        props.alignEnd &&
        css`
            align-items: flex-end !important;
        `}
    ${(props) =>
        props.justifyEnd &&
        css`
            justify-content: flex-end;
        `}
    
    ${(props) =>
        props.column &&
        css`
            flex-direction: column;
        `}
    
    ${(props) =>
        props.width &&
        css`
            width: ${props.width}px;
        `}
    ${(props) =>
        props.widthPercentage &&
        css`
            width: ${props.widthPercentage}%;
        `}

    ${(props) =>
        props.maxWidth &&
        css`
            max-width: ${props.maxWidth}px;
        `}
    ${(props) =>
        props.maxWidthPercentage &&
        css`
            max-width: ${props.maxWidthPercentage}%;
        `}

    ${(props) =>
        props.fullWidth &&
        css`
            width: 100%;
        `}

    ${(props) =>
        props.minWidth &&
        css`
            min-width: ${props.minWidth}px;
        `}
        
    ${(props) =>
        props.height &&
        css`
            height: ${props.height}px;
        `}
    
    ${(props) =>
        props.maxHeight &&
        css`
            max-height: ${props.maxHeight}px;
        `}
        
    ${(props) =>
        props.minHeight &&
        css`
            min-height: ${props.minHeight}px;
        `}

    ${(props) =>
        props.fullHeight &&
        css`
            height: 100%;
        `}
    
    ${(props) =>
        props.flexGrow &&
        css`
            flex: ${props.flexGrow};
        `}
    ${(props) =>
        getProp(props, 'borderBottom') &&
        css`
            border-bottom: 1px solid ${palette.lightroom.heavyMetalLightHigh};
        `}
    ${(props) =>
        props.borderTop &&
        css`
            border-top: 1px solid ${palette.lightroom.heavyMetalLightHigh};
        `}
    ${(props) =>
        props.borderRight &&
        css`
            border-right: 1px solid ${palette.lightroom.heavyMetalLightHigh};
        `}
        
    ${(props) =>
        props.border &&
        css`
            border: 1px solid ${palette.lightroom.heavyMetalLightHigh};
            border-radius: 2px;
        `}
    ${(props) =>
        props.borderWidth &&
        css`
            border-width: ${props.borderWidth}px;
        `}
    ${(props) =>
        props.borderStyle &&
        css`
            border-style: ${props.borderStyle};
        `}
    ${(props) =>
        props.borderColor &&
        css`
            border-color: ${props.borderColor};
        `}
    ${(props) =>
        props.borderRadius &&
        css`
            border-radius: ${props.borderRadius}px;
        `}
    
    ${(props) =>
        props.overflowYauto &&
        css`
            overflow-y: auto;
        `}
    ${(props) =>
        props.overflowXauto &&
        css`
            overflow-x: auto;
        `}
    ${(props) =>
        props.overflowHidden &&
        css`
            overflow: hidden;
        `}
    ${(props) =>
        props.opacity &&
        css`
            opacity: ${props.opacity};
        `}
   ${(props) =>
        props.hideScrollbar &&
        css`
            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none; /* Firefox */
            &::-webkit-scrollbar {
                display: none; /* all other browsers */
            }
        `}
     

    ${(props) =>
        props.link &&
        css`
            cursor: pointer;
        `}
    ${(props) =>
        props.positionRelative &&
        css`
            position: relative;
        `}
    ${(props) =>
        props.positionAbsolute &&
        css`
            position: absolute;
        `}
    ${(props) =>
        props.positionSticky &&
        css`
            position: sticky;
        `}
    ${(props) =>
        props.expandFullyOverParent &&
        css`
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
        `}
    ${(props) =>
        props.top &&
        css`
            top: ${props.top}px;
        `}
    ${(props) =>
        props.left &&
        css`
            left: ${props.left}px;
        `}
     ${(props) =>
        props.right &&
        css`
            right: ${props.right}px;
        `}
    ${(props) =>
        props.zIndex &&
        css`
            z-index: ${props.zIndex};
        `}
    
    ${(props) =>
        props.wrapper &&
        css`
            width: 100%;
            min-height: 100%;
        `}
    ${(props) =>
        props.layoutWrapper &&
        css`
            flex-direction: column;
            min-height: 100vh;
        `}
    ${(props) =>
        props.columnReverse &&
        css`
            flex-direction: column-reverse;
        `}    
    
    ${(props) =>
        props.column &&
        css`
            flex-direction: column;
        `}
    ${(props) =>
        props.rowReverse &&
        css`
            flex-direction: row-reverse;
        `}
    ${(props) =>
        props.ignoreParentPadding &&
        css`
            margin: -${props.ignoreParentPadding}px;
            max-width: initial;
        `}
    ${(props) =>
        props.gap &&
        css`
            gap: ${props.gap}px;
        `}

    ${(props) =>
        props.rowGap &&
        css`
            row-gap: ${props.rowGap}px;
        `}
    ${(props) =>
        getProp(props, 'desktopOnly') &&
        css`
            @media (max-width: 992px) {
                display: none !important;
            }
        `}
    ${(props) =>
        getProp(props, 'mobileOnly') &&
        css`
            display: none;
            @media (max-width: 992px) {
                display: flex;
            }
        `}

    ${(props) =>
        getProp(props, 'stackOnMobile') &&
        css`
            @media (max-width: 992px) {
                flex-direction: column;
                flex-wrap: nowrap;
            }
        `}
    
    ${(props) =>
        props.visibilityHidden &&
        css`
            visibility: hidden;
        `}
`;

export const Block = styled(FlexDiv)`
    background: white;
    border-radius: 2px;
    padding: 32px;
    margin-top: 20px;
    flex-direction: column;
    border: 1px solid rgba(29, 30, 29, 0.07);
    @media (max-width: 992px) {
        padding: 32px 16px;
    }

    ${(props) =>
        props.paddingTopOnly &&
        css`
            padding: 32px 0 0 0;
            @media (max-width: 992px) {
                padding: 32px 0 0 0;
            }
        `}
    ${(props) =>
        props.resetMargin &&
        css`
            margin: 0;
        `}
    ${(props) =>
        props.resetPadding &&
        css`
            padding: 0;
            @media (max-width: 992px) {
                padding: 0;
            }
        `}
    ${(props) =>
        props.tablePadding &&
        css`
            padding: 32px 16px 16px 16px;
            @media (max-width: 992px) {
                padding: 32px 16px 16px 16px;
            }
        `}

        ${(props) =>
        props.noBorder &&
        css`
            border: none;
        `}
`;

export const SpaceBetweenDiv = styled(FlexDiv)`
    justify-content: space-between;
    align-items: center;
    width: 100%;

    ${(props) =>
        props.widthInitial &&
        css`
            width: initial;
        `}
`;

export const GridDiv = styled.div`
    display: grid;
    width: 100%;

    ${(props) =>
        props.columns &&
        css`
            grid-template-columns: repeat(${props.columns}, 1fr);
        `}

    /** Minimum width of each item in the grid, if below it (resizing window) the grid just displays fewer items in the line*/
    ${(props) =>
        props.minItemWidth &&
        css`
            grid-template-columns: repeat(
                auto-fill,
                minmax(${props.minItemWidth}px, 1fr)
            );
        `}

    ${(props) =>
        props.gap &&
        css`
            gap: ${props.gap}px;
        `}
`;

export const Image = styled.img`
    ${(props) =>
        props.height &&
        css`
            height: ${props.height}px;
        `}
    ${(props) =>
        props.width &&
        css`
            width: ${props.width}px;
        `}
    ${(props) =>
        props.maxWidth &&
        css`
            max-width: ${props.maxWidth}px;
        `}
    ${(props) =>
        props.minWidth &&
        css`
            min-width: ${props.minWidth}px;
        `}
    ${(props) =>
        props.fullWidth &&
        css`
            width: 100%;
        `}
    ${(props) =>
        props.link &&
        css`
            cursor: pointer;
        `}
    ${(props) =>
        props.borderRadius &&
        css`
            border-radius: ${props.borderRadius}px;
        `}

    ${(props) =>
        props.cover &&
        css`
            object-fit: cover;
        `}
    
    ${(props) =>
        props.coverTop &&
        css`
            object-fit: cover;
            object-position: 50% 0;
        `}
    
    ${(props) =>
        props.cover &&
        css`
            object-fit: cover;
        `}

    ${(props) =>
        props.contain &&
        css`
            object-fit: contain;
        `}
    
    ${(props) =>
        props.borderRadiusTop &&
        css`
            border-top-left-radius: ${props.borderRadiusTop}px;
            border-top-right-radius: ${props.borderRadiusTop}px;
        `}
    ${(props) =>
        props.border &&
        css`
            border: 1px solid ${palette.lightroom.heavyMetalLightHigh};
        `}
    
    ${(props) =>
        props.dropShadow &&
        css`
            filter: drop-shadow(rgba(0, 0, 0, 0.16) 0px 5px 3px)
                drop-shadow(rgba(0, 0, 0, 0.33) 0px 5px 6px);
            transform: translateZ(
                0
            ); //Needed to make the shadow show up in one piece on first render in Safari
        `}

    ${(props) =>
        props.desktopOnly &&
        css`
            @media (max-width: 992px) {
                display: none !important;
            }
        `}
    ${(props) =>
        props.mobileOnly &&
        css`
            display: none;
            @media (max-width: 992px) {
                display: flex;
            }
        `}
`;
